export default "__VITE_ASSET__59e984f0__"